import { createApp } from 'vue'
import App from './App.vue'
import PrimeVue from 'primevue/config';
import Button from 'primevue/button';
import mitt from 'mitt';

import 'primevue/resources/themes/nova-vue/theme.css';
import 'primevue/resources/primevue.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';

import './assets/css/mapbox-gl-2.1.1.css';
import './assets/css/main.css';
import './assets/css/button.css';

window.storeLocatorBus = mitt();

const app = createApp(App);

app.use(PrimeVue);
app.component('Button', Button);
app.mount('#store-locator-map');
